<template>
	<div id="confirm">
		<div class="confirm_wrap user-select">
			<p class="clearfix title">
				<span class="pull-left color_9">确认操作</span>
				<i class="glyphicon icon_off pull-right cursor" @click="confirmOff"></i>
			</p>
			<div class="content">
				<h4 class="top_content text-center color_6">
					确认{{bigMsg}}
				</h4>
				<p class="text-center color_6">
					<small>
						{{smallMsg}}
					</small>
				</p>
				<p class="text-center margin_btn">
					<span class="btn Cbtn btn_default" @click="confirmTrue">确认</span>
					<span class="btn btn_qx" @click="confirmOff">取消</span>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	export default {
		data() {
			return {}
		},
		props: [
			'bigMsg',
			'smallMsg'
		],
		methods: {
			confirmTrue() {
				this.$emit("confirmTrue");
			},
			confirmOff() {
				this.$emit("confirmOff");
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#confirm {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1040;
		overflow-x: hidden;
		overflow-y: auto;
	}
	
	.confirm_wrap {
		position: relative;
		margin: 100px auto 50px;
		width: 358px;
		/*height: 215px;*/
		background-color: #fff;
		padding: 10px;
		border-radius: 10px;
		-webkit-box-shadow: 0 0 10px rgba(0,0,0,0.4);
		-moz-box-shadow: 0 0 10px rgba(0,0,0,0.4);
		box-shadow: 0 0 10px rgba(0,0,0,0.4);
	}
	
	.content h4 {
		margin-bottom: 20px;
	}
	
	.content p {
		margin-top: 24px;
	}
	
	.content p button {
		margin: 0 15px;
	}
	.btn_default:focus, .btn_default:hover {
	    color: #fff;
	    text-decoration: none;
	}
	.btn_qx {
		color: #333;
		background-color: #ccc;
		margin-left: 15px;
	}
</style>


// WEBPACK FOOTER //
// confirm.vue?9f79e84c